import { SankeyLink } from '../types/sankey';

export const RVC1: SankeyLink[] = [
    {
        source: 103,
        target: 9,
        value: 1,
        valueid: 'targetba',
        paperName: 'DMC09',
        process: 'DMC09_1',
        id: 'DMC09-0',
        cluster: 'rvc1',
        imgUrl: 'KTkfwLw.png',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    {
        source: 103,
        target: 11,
        value: 1,
        valueid: 'targetba',
        paperName: 'DMC09',
        process: 'DMC09_2',
        id: 'DMC09-1',
        cluster: 'rvc1',
        imgUrl: 'KTkfwLw.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 9, target: 36, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-2', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'intOneLight3LinkColor' },
    { source: 11, target: 42, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-3', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'intThreeLightLinkColor' },
    { source: 36, target: 58, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-4', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'intOneLight3LinkColor' },
    { source: 42, target: 58, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-5', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'intThreeLightLinkColor' },
    { source: 58, target: 76, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-6', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'repVisVarColor' },
    { source: 58, target: 76, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-7', cluster: 'rvc1', imgUrl: 'KTkfwLw.png', color: 'repVisVarColor' },
    { source: 113, target: 9, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-0', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'targetLinkOneColor', status: 'selected' },
    { source: 113, target: 10, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-3', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'targetLinkOneColor', status: 'selected' },
    { source: 9, target: 36, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-10', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 10, target: 36, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-13', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 36, target: 53, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-21', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 53, target: 76, value: 1, valueid: 'repc', paperName: 'JX17', process: 'JX17_1', id: 'JX17-27', cluster: 'rvc1', imgUrl: 'dbYhmdg.jpg', color: 'repVisVarColor' },
    {
        source: 115,
        target: 11,
        value: 1,
        valueid: 'repea ',
        paperName: 'LGX16',
        process: 'LGX16_4',
        id: 'LGX16-3',
        cluster: 'rvc1',
        imgUrl: 'WcypLMa.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 115,
        target: 12,
        value: 1,
        valueid: 'repea ',
        paperName: 'LGX16',
        process: 'LGX16_4',
        id: 'LGX16-4',
        cluster: 'rvc1',
        imgUrl: 'WcypLMa.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 33, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-10', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intOneLinkColor' },
    { source: 11, target: 45, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-11', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 12, target: 33, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-12', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intOneLinkColor' },
    { source: 12, target: 45, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-13', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 33, target: 59, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-19', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { source: 45, target: 59, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-20', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 59, target: 76, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-28', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    {
        source: 122,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-0',
        cluster: 'rvc1',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 122,
        target: 12,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-1',
        cluster: 'rvc1',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-2', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-3', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-4', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { source: 12, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-5', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { source: 11, target: 49, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-6', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intFiveLight2LinkColor' },
    { source: 12, target: 49, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-7', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intFiveLight2LinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-8', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-9', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-10',
        cluster: 'rvc1',
        imgUrl: 'Ak8KSur.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-11', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    {
        source: 123,
        target: 17,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-3',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 19,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-4',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 17, target: 48, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-14', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 17,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-15',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 19, target: 48, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-16', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 19,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-17',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 48, target: 55, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-24', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-25',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 76, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-28', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'repVisVarColor' },

    { source: 50, target: 76, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-9', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    {
        source: 132,
        target: 16,
        value: 1,
        valueid: 'repc',
        paperName: 'XD99',
        process: ' XD99_2',
        id: 'XD99-1',
        cluster: 'rvc1',
        imgUrl: 'CaBMwKE.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 43, value: 1, valueid: 'repc', paperName: 'XD99', process: ' XD99_2', id: 'XD99-7', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 53, value: 1, valueid: 'repc', paperName: 'XD99', process: ' XD99_2', id: 'XD99-13', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'intThreeLight1LinkColor' },
    { source: 53, target: 76, value: 1, valueid: 'repc', paperName: 'XD99', process: ' XD99_2', id: 'XD99-15', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'repVisVarColor' },
    {
        source: 134,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_5',
        id: 'XWS16-4',
        cluster: 'rvc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 45, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-12', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 53, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-18', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-22', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    {
        source: 135,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_1',
        id: 'YFS10-0',
        cluster: 'rvc1',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 34, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-1', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-2', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 34, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-3', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-4', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 59, target: 76, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-5', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    {
        source: 135,
        target: 12,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_2',
        id: 'YFS10-8',
        cluster: 'rvc1',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 34, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-9', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 12, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-10', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 34, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-11', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-12', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 59, target: 76, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-13', cluster: 'rvc1', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    {
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-0',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 42,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-1',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 15, target: 45, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-2', cluster: 'rvc1', imgUrl: 'u2sWSNe.jpg', color: 'intFourLinkColor' },
    {
        source: 42,
        target: 60,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-3',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 45, target: 60, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-4', cluster: 'rvc1', imgUrl: 'u2sWSNe.jpg', color: 'intFourLinkColor' },
    { source: 60, target: 76, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-5', cluster: 'rvc1', imgUrl: 'u2sWSNe.jpg', color: 'repVisVarColor' },
    {
        source: 141,
        target: 16,
        value: 1,
        valueid: 'reph',
        paperName: 'YSK14',
        process: 'YSK14_4',
        id: 'YSK14-3',
        cluster: 'rvc1',
        imgUrl: 'sBwMjs9.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 141,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_6',
        id: 'YSK14-4',
        cluster: 'rvc1',
        imgUrl: 'sBwMjs9.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 16, target: 48, value: 1, valueid: 'reph', paperName: 'YSK14', process: 'YSK14_4', id: 'YSK14-10', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'intFiveLightLinkColor' },
    { source: 22, target: 46, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-13', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { source: 46, target: 62, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-17', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { source: 48, target: 62, value: 1, valueid: 'reph', paperName: 'YSK14', process: 'YSK14_4', id: 'YSK14-20', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'intFiveLightLinkColor' },
    { source: 62, target: 76, value: 1, valueid: 'reph', paperName: 'YSK14', process: 'YSK14_4', id: 'YSK14-23', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'repVisVarColor' },
    { source: 62, target: 76, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-24', cluster: 'rvc1', imgUrl: 'sBwMjs9.png', color: 'repVisVarColor' },
    {
        source: 144,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-3',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 32, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-9', cluster: 'rvc1', imgUrl: 'RYq4EGR.jpg', color: 'intOneLinkColor' },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-11',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-12', cluster: 'rvc1', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-13',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-17',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 32, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-19', cluster: 'rvc1', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-20',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-21', cluster: 'rvc1', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-22',
        cluster: 'rvc1',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-25', cluster: 'rvc1', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_2',
        id: 'GYS14-2',
        cluster: 'rvc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_4',
        id: 'GYS14-4',
        cluster: 'rvc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 18,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_6',
        id: 'GYS14-5',
        cluster: 'rvc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 18,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_5',
        id: 'GYS14-7',
        cluster: 'rvc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-11', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 11, target: 47, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-12', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 45, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-14', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 18, target: 47, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-15', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 45, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-18', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-19', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-21', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-22', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 54, target: 76, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-25', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 76, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-26', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 76, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-27', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 76, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-28', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    {
        source: 148,
        target: 9,
        value: 1,
        valueid: 'repeb',
        paperName: 'KWL09',
        process: 'KWL09_1',
        id: 'KWL09-0',
        cluster: 'rvc1',
        imgUrl: 'ukgueox.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    { source: 36, target: 59, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-3', cluster: 'rvc1', imgUrl: 'ukgueox.jpg', color: 'intOneLight3LinkColor' },
    { source: 59, target: 76, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-4', cluster: 'rvc1', imgUrl: 'ukgueox.jpg', color: 'repVisVarColor' },
    {
        source: 150,
        target: 6,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_1',
        id: 'MLG06-0',
        cluster: 'rvc1',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 150,
        target: 12,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-1',
        cluster: 'rvc1',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 6, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-2', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-3', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 49, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-5', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intFiveLight2LinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-6', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-7', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 42, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-8', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intThreeLightLinkColor' },
    { source: 49, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-9', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'intFiveLight2LinkColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-10', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-11', cluster: 'rvc1', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    {
        source: 152,
        target: 0,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-3',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-4',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-5',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 0,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-6',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-7',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-8',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 0,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-9',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-10',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-11',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 11,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-12',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 0, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-28', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 3, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-29', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 6, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-30', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 0, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-31', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    { source: 3, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-32', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    { source: 6, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-33', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 0,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-34',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 3,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-35',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 6,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-36',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 39, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-37', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 41, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-38', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 42,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-39',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-40', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    {
        source: 0,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-43',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 3,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-44',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 6,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-45',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-46',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 76, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-47', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    {
        source: 0,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-50',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 3,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-51',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 6,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-52',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-53',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_4', id: 'WHWS12-54', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { source: 11, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-57', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-58', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-59',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 11, target: 45, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-60', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intFourLinkColor' },
    { source: 39, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-61', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 41, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-62', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 42,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-63',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 45, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-64', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intFourLinkColor' },
    { source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-65', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    {
        source: 154,
        target: 14,
        value: 1,
        valueid: 'repf',
        paperName: 'ATSC06',
        process: 'ATSC06_2',
        id: 'ASTC06-0',
        cluster: 'rvc1',
        imgUrl: '1mwkKcH.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 154,
        target: 15,
        value: 1,
        valueid: 'repf',
        paperName: 'ATSC06',
        process: 'ATSC06_2',
        id: 'ASTC06-4',
        cluster: 'rvc1',
        imgUrl: '1mwkKcH.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 154,
        target: 16,
        value: 1,
        valueid: 'repf',
        paperName: 'ATSC06',
        process: 'ATSC06_5',
        id: 'ASTC06-8',
        cluster: 'rvc1',
        imgUrl: '1mwkKcH.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 14, target: 43, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_2', id: 'ASTC06-16', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'intThreeLight1LinkColor' },
    { source: 15, target: 43, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_2', id: 'ASTC06-17', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 60, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_2', id: 'ASTC06-18', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'intThreeLight1LinkColor' },
    { source: 60, target: 76, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_2', id: 'ASTC06-19', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'repVisVarColor' },
    { source: 16, target: 43, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_5', id: 'ASTC06-33', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 60, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_5', id: 'ASTC06-34', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'intThreeLight1LinkColor' },
    { source: 60, target: 76, value: 1, valueid: 'repf', paperName: 'ATSC06', process: 'ATSC06_5', id: 'ASTC06-35', cluster: 'rvc1', imgUrl: '1mwkKcH.jpg', color: 'repVisVarColor' },
    {
        source: 157,
        target: 5,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_2',
        id: 'SFJ16-4',
        cluster: 'rvc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 22,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_2',
        id: 'SFJ16-5',
        cluster: 'rvc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 5, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-16', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 22, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-17', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 46, target: 54, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-18', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 54, target: 76, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-19', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'repVisVarColor' },
    {
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_3',
        id: 'CGK21-4',
        cluster: 'rvc1',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 101,
        target: 16,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_7',
        id: 'CGK21-8',
        cluster: 'rvc1',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 15, target: 32, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-14', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'intOneLinkColor' },
    { source: 16, target: 41, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-18', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 32, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-22', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    { source: 41, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-25', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 59, target: 79, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-40', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    { source: 59, target: 79, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-41', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    {
        source: 102,
        target: 11,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-1',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 12,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-3',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 17,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_3',
        id: 'CSL12-4',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 18,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_3',
        id: 'CSL12-5',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 19,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_3',
        id: 'CSL12-6',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 17, target: 48, value: 1, valueid: ['targetab', 'repc'], paperName: 'CSL12', process: 'CSL12_3', id: 'CSL12-17', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 48, value: 1, valueid: ['targetab', 'repc'], paperName: 'CSL12', process: 'CSL12_3', id: 'CSL12-18', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 19, target: 48, value: 1, valueid: ['targetab', 'repc'], paperName: 'CSL12', process: 'CSL12_3', id: 'CSL12-19', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 48, target: 53, value: 1, valueid: ['targetab', 'repc'], paperName: 'CSL12', process: 'CSL12_3', id: 'CSL12-28', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },

    {
        source: 53,
        target: 79,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-35',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    { source: 53, target: 79, value: 1, valueid: ['targetab', 'repc'], paperName: 'CSL12', process: 'CSL12_3', id: 'CSL12-36', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    {
        source: 104,
        target: 15,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-0',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 104,
        target: 18,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-2',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 41,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-4',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 15,
        target: 42,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-5',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 15,
        target: 43,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-6',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    {
        source: 18,
        target: 41,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-8',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 18,
        target: 42,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-9',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 18,
        target: 43,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-10',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    {
        source: 41,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-12',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-13',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 42,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-14',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-15',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 43,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-16',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    {
        source: 43,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-17',
        cluster: 'rvc1',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    { source: 52, target: 79, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_1', id: 'EAIA17-22', cluster: 'rvc1', imgUrl: 'TFuj7MS.jpg', color: 'repVisVarColor' },
    { source: 52, target: 79, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_3', id: 'EAIA17-23', cluster: 'rvc1', imgUrl: 'TFuj7MS.jpg', color: 'repVisVarColor' },
    {
        source: 106,
        target: 5,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_1',
        id: 'FCF09-0',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_1',
        id: 'FCF09-1',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_1',
        id: 'FCF09-2',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 5,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_3',
        id: 'FCF09-6',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_3',
        id: 'FCF09-7',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_3',
        id: 'FCF09-8',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 5, target: 40, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_1', id: 'FCF09-10', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intTwoLightLinkColor' },
    { source: 17, target: 40, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_1', id: 'FCF09-13', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intTwoLightLinkColor' },

    { source: 18, target: 40, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_1', id: 'FCF09-16', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intTwoLightLinkColor' },

    { source: 40, target: 62, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_1', id: 'FCF09-20', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intTwoLightLinkColor' },
    { source: 45, target: 62, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-22', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { source: 62, target: 79, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_1', id: 'FCF09-27', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    { source: 62, target: 79, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-28', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    {
        source: 109,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'GGS12TPS',
        process: 'GGS12TPS_1',
        id: 'GGS12TPS-0',
        cluster: 'rvc1',
        imgUrl: 'au5KByH.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 109,
        target: 16,
        value: 1,
        valueid: 'targetbb',
        paperName: 'GGS12TPS',
        process: 'GGS12TPS_2',
        id: 'GGS12TPS-1',
        cluster: 'rvc1',
        imgUrl: 'au5KByH.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 12, target: 42, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-3', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'intThreeLightLinkColor' },
    { source: 16, target: 43, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_2', id: 'GGS12TPS-4', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'intThreeLight1LinkColor' },
    { source: 42, target: 64, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-6', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'intThreeLightLinkColor' },
    { source: 43, target: 64, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_2', id: 'GGS12TPS-7', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'intThreeLight1LinkColor' },
    { source: 64, target: 79, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-10', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'repVisVarColor' },
    { source: 64, target: 79, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_2', id: 'GGS12TPS-11', cluster: 'rvc1', imgUrl: 'au5KByH.png', color: 'repVisVarColor' },
    {
        source: 117,
        target: 24,
        value: 1,
        valueid: 'targetab',
        paperName: 'LLN14',
        process: 'LLN14_4',
        id: 'LLN14-4',
        cluster: 'rvc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 24, target: 46, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-21', cluster: 'rvc1', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { source: 46, target: 55, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-22', cluster: 'rvc1', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { source: 55, target: 79, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-23', cluster: 'rvc1', imgUrl: 'xWQU5gc.jpg', color: 'repVisVarColor' },
    {
        source: 118,
        target: 9,
        value: 1,
        valueid: ['targetca', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_1',
        id: 'LWW13-0',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    {
        source: 118,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_2',
        id: 'LWW13-1',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 118,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-2',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 118,
        target: 13,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_2',
        id: 'LWW13-3',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },

    {
        source: 11,
        target: 35,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_2',
        id: 'LWW13-11',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intOneLight2LinkColor',
    },
    {
        source: 13,
        target: 35,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_2',
        id: 'LWW13-12',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intOneLight2LinkColor',
    },

    {
        source: 35,
        target: 59,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_2',
        id: 'LWW13-17',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intOneLight2LinkColor',
    },
    { source: 59, target: 79, value: 1, valueid: ['targetca', 'repeb'], paperName: 'LWW13', process: 'LWW13_1', id: 'LWW13-25', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { source: 59, target: 79, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_2', id: 'LWW13-26', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { source: 59, target: 79, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_3', id: 'LWW13-27', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    {
        source: 123,
        target: 2,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_1',
        id: 'MVM17-0',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 4,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_1',
        id: 'MVM17-1',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 7,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_1',
        id: 'MVM17-2',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 21,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_3',
        id: 'MVM17-5',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 22,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_3',
        id: 'MVM17-6',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 23,
        value: 1,
        valueid: 'targetca',
        paperName: 'MVM17',
        process: 'MVM17_3',
        id: 'MVM17-7',
        cluster: 'rvc1',
        imgUrl: 'U35x588.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 2, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-8', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 4, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-9', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 7, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-10', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 2, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-11', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { source: 4, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-12', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { source: 7, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-13', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { source: 21, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-18', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 22, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-19', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 23, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-20', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 46, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-21', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 46, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-22', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { source: 49, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-23', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { source: 60, target: 79, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-31', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { source: 60, target: 79, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-32', cluster: 'rvc1', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    {
        source: 125,
        target: 0,
        value: 1,
        valueid: 'targetab',
        paperName: 'PC15PV',
        process: 'PC15PV_1',
        id: 'PC15PV-0',
        cluster: 'rvc1',
        imgUrl: 'C2IpSkW.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 125,
        target: 12,
        value: 1,
        valueid: 'targetab',
        paperName: 'PC15PV',
        process: 'PC15PV_4',
        id: 'PC15PV-3',
        cluster: 'rvc1',
        imgUrl: 'C2IpSkW.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 0, target: 45, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-6', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'intFourLinkColor' },
    { source: 12, target: 49, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-9', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'intFiveLight2LinkColor' },
    { source: 45, target: 52, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-12', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'intFourLinkColor' },
    { source: 49, target: 52, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-13', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'intFiveLight2LinkColor' },
    { source: 52, target: 79, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-19', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'repVisVarColor' },
    { source: 52, target: 79, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-20', cluster: 'rvc1', imgUrl: 'C2IpSkW.jpg', color: 'repVisVarColor' },
    {
        source: 126,
        target: 0,
        value: 1,
        valueid: 'targetab',
        paperName: 'REP15',
        process: 'REP15_1',
        id: 'REP15-0',
        cluster: 'rvc1',
        imgUrl: 'y8mGv81.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 126,
        target: 9,
        value: 1,
        valueid: 'targetab',
        paperName: 'REP15',
        process: 'REP15_2',
        id: 'REP15-1',
        cluster: 'rvc1',
        imgUrl: 'y8mGv81.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },

    { source: 0, target: 40, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_1', id: 'REP15-3', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intTwoLightLinkColor' },
    { source: 9, target: 36, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_2', id: 'REP15-4', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intOneLight3LinkColor' },
    { source: 11, target: 45, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-5', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intFourLinkColor' },
    { source: 36, target: 50, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_2', id: 'REP15-6', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intOneLight3LinkColor' },
    { source: 40, target: 50, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_1', id: 'REP15-7', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intTwoLightLinkColor' },
    { source: 45, target: 50, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-8', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'intFourLinkColor' },
    { source: 50, target: 79, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_1', id: 'REP15-10', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { source: 50, target: 79, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_2', id: 'REP15-11', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { source: 50, target: 79, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-12', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    {
        source: 128,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_1',
        id: 'SCS17-0',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-1',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 44, value: 1, valueid: ['targetca', 'repa'], paperName: 'SCS17', process: 'SCS17_1', id: 'SCS17-7', cluster: 'rvc1', imgUrl: 'h29usSh.jpg', color: 'intThreeLight2LinkColor' },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_1',
        id: 'SCS17-8',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 63, target: 79, value: 1, valueid: ['targetca', 'repa'], paperName: 'SCS17', process: 'SCS17_1', id: 'SCS17-10', cluster: 'rvc1', imgUrl: 'h29usSh.jpg', color: 'repVisVarColor' },

    {
        source: 63,
        target: 79,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-21',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        source: 132,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'XD99',
        process: ' XD99_5',
        id: 'XD99-4',
        cluster: 'rvc1',
        imgUrl: 'CaBMwKE.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 22, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-9', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-16', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { source: 53, target: 79, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-23', cluster: 'rvc1', imgUrl: 'CaBMwKE.jpg', color: 'repVisVarColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_3',
        id: 'XWS16-0',
        cluster: 'rvc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-1',
        cluster: 'rvc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-9', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-11',
        cluster: 'rvc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 45, target: 53, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-17', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-19',
        cluster: 'rvc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 79, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-27', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { source: 53, target: 79, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_4', id: 'XWS16-28', cluster: 'rvc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    {
        source: 138,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_1',
        id: 'SRJ13-0',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 138,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-1',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 138,
        target: 16,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-2',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-4', cluster: 'rvc1', imgUrl: 'kgWl7nV.png', color: 'intTwoLinkColor' },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-5',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 16,
        target: 49,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-6',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 39, target: 55, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-8', cluster: 'rvc1', imgUrl: 'kgWl7nV.png', color: 'intTwoLinkColor' },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-9',
        cluster: 'rvc1',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 79, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-11', cluster: 'rvc1', imgUrl: 'kgWl7nV.png', color: 'repVisVarColor' },
    { source: 55, target: 79, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_2', id: 'SRJ13-12', cluster: 'rvc1', imgUrl: 'kgWl7nV.png', color: 'repVisVarColor' },
    {
        source: 142,
        target: 11,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_2',
        id: 'CSL16-1',
        cluster: 'rvc1',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 142,
        target: 13,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_4',
        id: 'CSL16-4',
        cluster: 'rvc1',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 142,
        target: 16,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_4',
        id: 'CSL16-5',
        cluster: 'rvc1',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-13', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 39, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-14', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 62, target: 79, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-15', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'repVisVarColor' },
    { source: 13, target: 48, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_4', id: 'CSL16-21', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intFiveLightLinkColor' },
    { source: 16, target: 48, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_4', id: 'CSL16-22', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intFiveLightLinkColor' },
    { source: 48, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_4', id: 'CSL16-23', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intFiveLightLinkColor' },
    { source: 62, target: 79, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_4', id: 'CSL16-24', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'repVisVarColor' },

    { source: 5, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-16', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 22, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-17', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 46, target: 54, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-18', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { source: 54, target: 79, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-21', cluster: 'rvc1', imgUrl: 'e3PRKTM.jpg', color: 'repVisVarColor' },
    {
        source: 100,
        target: 9,
        value: 1,
        valueid: ['repeb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_1',
        id: 'CAA20-0',
        cluster: 'rvc1',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    { source: 9, target: 36, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_1', id: 'CAA20-7', cluster: 'rvc1', imgUrl: 'DFBi3Mo.jpg', color: 'intOneLight3LinkColor' },
    {
        source: 36,
        target: 59,
        value: 1,
        valueid: ['repeb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_1',
        id: 'CAA20-15',
        cluster: 'rvc1',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'intOneLight3LinkColor',
    },
    { source: 59, target: 80, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_1', id: 'CAA20-28', cluster: 'rvc1', imgUrl: 'DFBi3Mo.jpg', color: 'repVisVarColor' },
    { source: 15, target: 32, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-14', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'intOneLinkColor' },
    { source: 32, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-22', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    { source: 59, target: 80, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-42', cluster: 'rvc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    {
        source: 102,
        target: 17,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-7',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 18,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-8',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 19,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-9',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_5',
        id: 'CSL12-10',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-12',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-15',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-16',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 17, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-20', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-21', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 19, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-22', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 21, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-23', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    {
        source: 22,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-25',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-27', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    { source: 48, target: 62, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-29', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-30',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-31',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 80, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-37', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_7', id: 'CSL12-38', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    {
        source: 53,
        target: 80,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-39',
        cluster: 'rvc1',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    { source: 62, target: 80, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-40', cluster: 'rvc1', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    {
        source: 106,
        target: 5,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-3',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-4',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-5',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },

    { source: 5, target: 42, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_2', id: 'FCF09-11', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intThreeLightLinkColor' },
    { source: 5, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-12', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    {
        source: 17,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-14',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'intThreeLightLinkColor',
    },
    { source: 17, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-15', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    {
        source: 18,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-17',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'intThreeLightLinkColor',
    },
    { source: 18, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-18', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    {
        source: 42,
        target: 62,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-21',
        cluster: 'rvc1',
        imgUrl: 'FfzA9S4.png',
        color: 'intThreeLightLinkColor',
    },
    { source: 45, target: 62, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-22', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { source: 62, target: 80, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_2', id: 'FCF09-29', cluster: 'rvc1', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    {
        source: 110,
        target: 11,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-0',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 110,
        target: 12,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-1',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 34,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-2',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 12,
        target: 34,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-3',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 11,
        target: 36,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-4',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 12,
        target: 36,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-5',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 11,
        target: 40,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-6',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 12,
        target: 40,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-7',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-8',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 12,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-9',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-10',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-11',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 34,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-12',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 36,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-13',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 40,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-14',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 41,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-15',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-16',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 60,
        target: 80,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-17',
        cluster: 'rvc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'repVisVarColor',
    },
    {
        source: 112,
        target: 0,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_1',
        id: 'JSM16-0',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 112,
        target: 11,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-2',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 112,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-3',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 0, target: 48, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_1', id: 'JSM16-7', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'intFiveLightLinkColor' },
    { source: 11, target: 39, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-9', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'intTwoLinkColor' },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-10',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 11,
        target: 44,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-11',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-12',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 12, target: 39, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-13', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'intTwoLinkColor' },
    {
        source: 12,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-14',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 12,
        target: 44,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-15',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-16',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 39, target: 53, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-19', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'intTwoLinkColor' },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-20',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 44,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-21',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 48, target: 53, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_1', id: 'JSM16-23', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-24',
        cluster: 'rvc1',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 80, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_1', id: 'JSM16-28', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-29', cluster: 'rvc1', imgUrl: 'n4jwcKO.jpg', color: 'repVisVarColor' },
    {
        source: 115,
        target: 17,
        value: 1,
        valueid: 'repg ',
        paperName: 'LGX16',
        process: 'LGX16_5',
        id: 'LGX16-5',
        cluster: 'rvc1',
        imgUrl: 'WcypLMa.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 115,
        target: 19,
        value: 1,
        valueid: 'repg ',
        paperName: 'LGX16',
        process: 'LGX16_5',
        id: 'LGX16-6',
        cluster: 'rvc1',
        imgUrl: 'WcypLMa.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 17, target: 45, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-14', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 19, target: 45, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-15', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 45, target: 59, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-20', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 45, target: 68, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-21', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { source: 59, target: 80, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-30', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { source: 68, target: 80, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-31', cluster: 'rvc1', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { source: 9, target: 36, value: 1, valueid: ['targetca', 'repeb'], paperName: 'LWW13', process: 'LWW13_1', id: 'LWW13-8', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'intOneLight3LinkColor' },
    { source: 9, target: 40, value: 1, valueid: ['targetca', 'repeb'], paperName: 'LWW13', process: 'LWW13_1', id: 'LWW13-9', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'intTwoLightLinkColor' },
    { source: 40, target: 59, value: 1, valueid: ['targetca', 'repeb'], paperName: 'LWW13', process: 'LWW13_1', id: 'LWW13-10', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'intTwoLightLinkColor' },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-13',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 36,
        target: 59,
        value: 1,
        valueid: ['targetca', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_1',
        id: 'LWW13-18',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 49,
        target: 59,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-19',
        cluster: 'rvc1',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 59, target: 80, value: 1, valueid: ['targetca', 'repeb'], paperName: 'LWW13', process: 'LWW13_1', id: 'LWW13-28', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { source: 59, target: 80, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_3', id: 'LWW13-29', cluster: 'rvc1', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-14', cluster: 'rvc1', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    {
        source: 126,
        target: 11,
        value: 1,
        valueid: 'targetab',
        paperName: 'REP15',
        process: 'REP15_3',
        id: 'REP15-2',
        cluster: 'rvc1',
        imgUrl: 'y8mGv81.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },

    { source: 50, target: 80, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_1', id: 'REP15-13', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { source: 50, target: 80, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_2', id: 'REP15-14', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { source: 50, target: 80, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-15', cluster: 'rvc1', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_1',
        id: 'SCS17-8',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 63, target: 80, value: 1, valueid: ['targetca', 'repa'], paperName: 'SCS17', process: 'SCS17_1', id: 'SCS17-11', cluster: 'rvc1', imgUrl: 'h29usSh.jpg', color: 'repVisVarColor' },
    {
        source: 11,
        target: 34,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-14',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 11,
        target: 44,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-15',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 11,
        target: 46,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-16',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        source: 34,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-17',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-18',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 46,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-19',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        source: 63,
        target: 80,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-22',
        cluster: 'rvc1',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        source: 130,
        target: 23,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_2',
        id: 'SSK12-4',
        cluster: 'rvc1',
        imgUrl: 'chAdr4B.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 23, target: 46, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-13', cluster: 'rvc1', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-14', cluster: 'rvc1', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { source: 60, target: 80, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-16', cluster: 'rvc1', imgUrl: 'chAdr4B.png', color: 'repVisVarColor' },
    {
        source: 137,
        target: 7,
        value: 1,
        valueid: 'targetca',
        paperName: 'ZLW13',
        process: 'ZLW13_1',
        id: 'ZLW13-0',
        cluster: 'rvc1',
        imgUrl: 'KvCmzam.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 137,
        target: 11,
        value: 1,
        valueid: 'targetca',
        paperName: 'ZLW13',
        process: 'ZLW13_1',
        id: 'ZLW13-1',
        cluster: 'rvc1',
        imgUrl: 'KvCmzam.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 42, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-3', cluster: 'rvc1', imgUrl: 'KvCmzam.png', color: 'intThreeLightLinkColor' },
    { source: 11, target: 42, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-4', cluster: 'rvc1', imgUrl: 'KvCmzam.png', color: 'intThreeLightLinkColor' },
    { source: 42, target: 55, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-5', cluster: 'rvc1', imgUrl: 'KvCmzam.png', color: 'intThreeLightLinkColor' },
    { source: 55, target: 80, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-8', cluster: 'rvc1', imgUrl: 'KvCmzam.png', color: 'repVisVarColor' },
    {
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-7',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 49,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-8',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 59,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-9',
        cluster: 'rvc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 59, target: 80, value: 1, valueid: ['repea', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_2', id: 'FAKM15-11', cluster: 'rvc1', imgUrl: 'u2sWSNe.jpg', color: 'repVisVarColor' },
    {
        source: 142,
        target: 16,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_5',
        id: 'CSL16-6',
        cluster: 'rvc1',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 43, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-25', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-26', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'intThreeLight1LinkColor' },
    { source: 62, target: 80, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-27', cluster: 'rvc1', imgUrl: 'mt871Nx.png', color: 'repVisVarColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-21', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-22', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 54, target: 80, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-35', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 80, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-36', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 80, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-37', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 54, target: 80, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-38', cluster: 'rvc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { source: 9, target: 36, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-2', cluster: 'rvc1', imgUrl: 'ukgueox.jpg', color: 'intOneLight3LinkColor' },
    { source: 36, target: 59, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-3', cluster: 'rvc1', imgUrl: 'ukgueox.jpg', color: 'intOneLight3LinkColor' },
    { source: 59, target: 80, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-6', cluster: 'rvc1', imgUrl: 'ukgueox.jpg', color: 'repVisVarColor' },
    {
        source: 152,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-13',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-68', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 41, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-69', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-70',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 39, target: 59, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-71', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intTwoLinkColor' },
    { source: 41, target: 59, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-72', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'intThreeLinkColor' },
    {
        source: 42,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-73',
        cluster: 'rvc1',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 59, target: 80, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-75', cluster: 'rvc1', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    {
        source: 155,
        target: 9,
        value: 1,
        valueid: ['targetca', 'repd'],
        paperName: 'DJM12',
        process: 'DJM12_4',
        id: 'DJM12-3',
        cluster: 'rvc1',
        imgUrl: 'nNNbNas.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    { source: 9, target: 36, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_4', id: 'DJM12-12', cluster: 'rvc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLight3LinkColor' },
    { source: 36, target: 55, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_4', id: 'DJM12-22', cluster: 'rvc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLight3LinkColor' },
    { source: 55, target: 80, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_4', id: 'DJM12-33', cluster: 'rvc1', imgUrl: 'nNNbNas.jpg', color: 'repVisVarColor' },
];
